<template>
  <DefaultLayout :disableFacilitatorTools="true">
    <div>
      <div class="text-center">
        <h4>{{ $t("title") }}</h4>
      </div>

      <br />
      {{ $t("enteremail") }}

      <br />
      <br />

      <small class="text-uppercase font-weight-bold">{{ $t("email") }}</small>
      <base-input
        id="input-email"
        class="mb-3"
        v-model="form.email"
        v-bind:placeholder="$t('email')"
        v-on:keyup.native.enter="onSubmit"
      />

      <div class="alert alert-primary" role="alert" v-if="alertMessage">
        {{ $t(alertMessage) }}
      </div>

      <div class="text-center" v-if="!emailSent">
        <base-button v-if="!emailSent" type="primary" v-on:click="onSubmit()">{{
          $t("submit")
        }}</base-button>

        <router-link to="/">
          <small>{{ $t("cancel") }}</small>
        </router-link>
      </div>
      <div class="text-center" v-else>
        <router-link to="/admin/login">
          {{ $t("back") }}
        </router-link>
      </div>
    </div>
  </DefaultLayout>
</template>

<script>
import { FadeTransition } from "vue2-transitions";
import { forgotPassword } from "@/services/APIService";
import DefaultLayout from '@/layouts/DefaultLayout.vue';

export default {
  components: { DefaultLayout },

  data() {
    return {
      form: {
        email: "",
      },
      alertMessage: "",
      emailSent: false,
      emailOnURI: false,
    };
  },
  created() {
    const { email } = this.$route.params;

    if (email) {
      this.form.email = email;
      this.emailOnURI = true;
      this.onSubmit();
    }
  },
  mounted() {},
  methods: {
    onSubmit() {
      if (!this.form.email) {
        this.alertMessage = "emailrequired";
        return;
      }

      this.form.email = this.form.email.toLowerCase();

      forgotPassword(
        this.form.email,
        this.$i18n.locale,
        window.location.origin + "/admin/changepassword/"
      )
        .then((response) => {
          this.alertMessage = this.emailOnURI ? "emailsent2" : "emailsent";
          this.emailSent = true;
        })
        .catch((error) => {
          if (error.response.status === 417) {
            // Too easy a password
            this.alertMessage = "tooeasypassword";
          } else {
            this.alertMessage = "tryagainlater";
          }
        });
    },
  },
};
</script>

<i18n>
{
  "en": {
    "email": "* Email address",
    "enteremail": "Input your email address and click \"Send\" to get instructions for setting your password.",
    "title": "Send the instructions for setting the password.",
    "submit": "Submit",
    "emailrequired": "Please fill in your email address before proceeding.",
    "emailsent": "If a user with this email address exists, instructions for setting the password have been sent to you.",
    "emailsent2": "Instructions for setting the password have been sent to you.",
    "sendfailed": "Failed to send password reset email. Please try again later.",
    "cancel": "Cancel",
    "back": "Go to log in page.",
    "tryagainlater": "Failed to send email. Please try again later."  },
  "fi": {
    "email": "* Sähköpostiosoite",
    "enteremail": "Syötä sähköpostiosoitteesi ja klikkaa Lähetä, niin saat ohjeet salasanan asettamiseksi.",
    "title": "Lähetä ohjeet salasanan asettamiseen",
    "submit": "Lähetä",
    "emailrequired": "Täytäthän sähköpostikentän ennen jatkamista.",
    "emailsent": "Jos antamallasi sähköpostiosoitteella löytyy käyttäjä, ohjeet salasanan asettamiseksi on lähetetty käyttäjän osoitteeseen.",
    "emailsent2": "Ohjeet salasanan asettamiseksi on lähetetty käyttäjän osoitteeseen.",
    "sendfailed": "Sähköpostin lähetys epäonnistui. Yritä uudestaan myöhemmin.",
    "cancel": "Peru",
    "back": "Siirry sisäänkirjautumiseen.",
    "tryagainlater": "Sähköpostin lähettäminen epäonnistui tuntemattomasta syystä. Yritä uudelleen myöhemmin."
  },
  "sv": {
    "email": "* E-postadress",
    "enteremail": "Skriv din e-postadress och klicka på \"Skicka\" för att få instruktioner för att välja lösenord.",
    "title": "Skicka instruktionerna för att välja lösenordet",
    "submit": "Skicka",
    "emailrequired": "Fyll i e-postfältet innan du fortsätter.",
    "emailsent": "Om e-postadressen du angav är i bruk har anvisningar för att välja lösenord skickats till användarens adress.",
    "emailsent2": "Anvisningar för att välja lösenord skickats till användarens adress.",
    "sendfailed": "Det gick inte att skicka e-post. Försök igen senare.",
    "cancel": "Gå till inloggningssidan.",
    "back": "Återgå till inloggning.",
    "tryagainlater": "E-postmeddelandet skickades inte av okänd anledning. Försök igen senare."
  },
  "de": {
    "email": "* E-Mail Adresse",
    "enteremail": "Geben Sie Ihre E-Mail-Adresse ein und klicken Sie auf \"Senden\", um Anweisungen zum Festlegen Ihres Passworts zu erhalten.",
    "title": "Senden Sie die Anweisungen zum Festlegen des Passworts",
    "submit": "Absenden",
    "emailrequired": "Bitte geben Sie Ihre E-Mail-Adresse ein, bevor Sie fortfahren.",
    "emailsent": "Wenn ein Benutzer mit dieser E-Mail-Adresse existiert, wurden Ihnen Anweisungen zur Änderung des Passworts zugesandt.",
    "emailsent2": "Anweisungen zur Änderung des Passworts zugesandt.",
    "sendfailed": "E-Mail zum Zurücksetzen des Passworts konnte nicht gesendet werden. Bitte versuchen Sie es später noch einmal.",
    "cancel": "Abbrechen",
    "back": "Gehen Sie zur Anmeldeseite",
    "tryagainlater": "E-Mail konnte nicht gesendet werden. Bitte versuchen Sie es später noch einmal."
  },
  "ko": {
    "email": "* 이메일 주소",
    "enteremail": "이메일 주소 입력 후 \"제출\"을 클릭해주십시오. 비밀번호 설정을 위한 안내사항이 전송됩니다.",
    "title": "비밀번호 설정 안내 보내기",
    "submit": "제출",
    "emailrequired": "이메일 주소를 입력해주십시오.",
    "emailsent": "이 이메일의 사용자가 유효하다면 비밀번호 설정 안내 메일이 전송됩니다.",
    "emailsent2": "비밀번호 설정 안내사항이 전송되었습니다.",
    "sendfailed": "비밀번호 재설정 이메일 전송에 실패하였습니다. 잠시 후 다시 시도해주십시오.",
    "cancel": "취소",
    "back": "로그인화면으로 가기",
    "tryagainlater": "이메일 전송에 실패하였습니다. 잠시 후 다시 시도해주십시오."
  }
}
</i18n>
